import styled from 'styled-components';
import * as React from 'react';

import { Line } from '../ui/divider/Line';
import { H1 } from './HeaderTitle';
import { Container } from './Container';
import { Maybe } from '../../../client/types/generated/types';
import { TextContainer } from './TextContainer';
import { SectionTextContainer } from './SectionTextContainer';

// Portal news side
export const SectionInfoStyle = styled.div<any>`
  background-color: ${({ theme, hidebackground }) =>
    hidebackground ? 'transparent' : theme.colors.redwine};
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 2em !important;
  padding: ${({ title }) => (title ? '3em 1em 1em 1em' : '1em')};

  h2 {
    font-size: 22px;
    color: ${({ theme }) => theme.colors.white};
    margin-top: 2em;
    width: 100%;
    max-width: 33em;
    text-align: center;
    font-weight: 300;
    padding: 0 30px;
  }
  .date {
    margin-bottom: 2em;
  }
  .ingress {
    p {
      font-size: 22px;
      width: 100%;
      max-width: 41em;
      margin: 0;
      padding: 0;
      :not(:first-child) {
        margin-top: 0.5em;
      }
    }
  }

  .intro {
    margin: 0 0 2em 0;
    width: 100%;

    p {
      margin: 0 0 1em 0;

      :last-child {
        margin-bottom: 0;
      }
    }
  }

  @media all and (max-width: 960px) {
    .ingress {
      p {
        font-size: 22px;
        width: 100%;
        max-width: 31em;
      }
    }
  }

  @media all and (max-width: 600px) {
    margin-top: -1em !important;
  }
  @media all and (max-width: 375px) {
    .ingress {
      p {
        font-size: 22px;
        width: 100%;
        max-width: 13em;
        padding: 0px 0em;
      }
    }
  }
`;

export const SectionInfoWide: React.FC<{
  date?: string;
  intro?: Maybe<string> | undefined;
  title?: Maybe<string> | undefined;
  ingress?: Maybe<string> | undefined;
  hidedivider?: boolean;
  info?: Maybe<string> | undefined;
  hidebackground?: boolean;
  link?: string;
  style?: any;
}> = ({
  date,
  intro,
  title,
  hidedivider,
  ingress,
  info,
  hidebackground,
  children,
  link,
  style,
}) => {
  return (
    <SectionInfoStyle
      title={title}
      hidebackground={hidebackground}
      style={style}
    >
      {date ? <p className="date">{date}</p> : null}
      {intro ? <SectionTextContainer className={'intro'} text={intro} /> : null}
      {title ? <H1>{title}</H1> : null}
      {!hidedivider ? (
        <Line style={{ marginTop: '-4px', marginBottom: '14px' }} />
      ) : null}
      {ingress ? (
        <p className="ingress" dangerouslySetInnerHTML={{ __html: ingress }} />
      ) : null}
      {info ? <SectionTextContainer text={info} /> : null}
      {children}
      {link ? <a href={link}>Les mer</a> : null}
    </SectionInfoStyle>
  );
};
